module.exports = __webpack_public_path__ + "assets/images/private ssp.svg";